    <div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">
      <b>Blog Kategorilerini Yönet</b>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <!-- Kategori Formu -->
      <div class="col-md-5">
        <div class="card">
          <div class="card-header bg-primary text-white">
            <h5 class="mb-0">{{ editingCategoryId ? 'Kategori Düzenle' : 'Yeni Kategori' }}</h5>
          </div>
          <div class="card-body">
            <form [formGroup]="categoryForm">
              <div class="form-group">
                <label>Dil *</label>
                <select class="form-control" formControlName="languageId">
                  <option value="">Dil Seçin</option>
                  <option *ngFor="let lang of languages" [value]="lang.id">
                    {{ lang.name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label>Kategori Adı *</label>
                <input type="text" class="form-control" formControlName="name">
              </div>

              <div class="form-group">
                <label>Slug (URL) *</label>
                <input type="text" class="form-control" formControlName="slug" placeholder="kategori-adi">
                <small class="text-muted">URL'de görünecek kısa isim</small>
              </div>

              <div class="form-group">
                <label>Açıklama</label>
                <textarea class="form-control" rows="3" formControlName="description"></textarea>
              </div>

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                  <label class="custom-control-label" for="isActive">Aktif</label>
                </div>
              </div>

              <div class="form-group">
                <button type="button" class="btn btn-primary" (click)="save()" [disabled]="submitted">
                  <i class="fa fa-spinner fa-spin" *ngIf="submitted"></i>
                  {{ editingCategoryId ? 'Güncelle' : 'Kaydet' }}
                </button>
                <button type="button" class="btn btn-secondary ml-2" (click)="resetForm()" *ngIf="editingCategoryId">
                  İptal
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Kategori Listesi -->
      <div class="col-md-7">
        <div class="card">
          <div class="card-header bg-info text-white">
            <h5 class="mb-0">Mevcut Kategoriler</h5>
          </div>
          <div class="card-body">
            <div *ngIf="loading" class="text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Yükleniyor...</span>
              </div>
            </div>

            <div *ngIf="!loading && categories.length === 0" class="alert alert-info">
              Henüz kategori bulunmamaktadır.
            </div>

            <div *ngIf="!loading && categories.length > 0" class="table-responsive">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Ad</th>
                    <th>Dil</th>
                    <th>Durum</th>
                    <th style="width: 100px">İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let category of categories">
                    <td>
                      <strong>{{ category.name }}</strong>
                      <br>
                      <small class="text-muted">{{ category.slug }}</small>
                    </td>
                    <td>
                      <span class="badge badge-info">{{ getLanguageName(category.languageId) }}</span>
                    </td>
                    <td>
                      <span [class]="category.isActive ? 'badge badge-success' : 'badge badge-secondary'">
                        {{ category.isActive ? 'Aktif' : 'Pasif' }}
                      </span>
                    </td>
                    <td>
                      <button class="btn btn-sm btn-warning" (click)="editCategory(category)" title="Düzenle">
                        <i class="fas fa-edit"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">Kapat</button>
  </div>
</div>
